import React, { useState, useEffect, useRef } from 'react';
import { db } from '../../firebase'; // Firestore instance
import { collection, onSnapshot, doc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore'; // Import onSnapshot for real-time updates
import '../Component/Component.css';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
// import * as React from 'react';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import BlockIcon from '@mui/icons-material/Block';
import AddUserForm from './AddUserForm';
import SyncLoader from "react-spinners/SyncLoader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const AllUsersTab = ({ relay }) => {
    const [users, setUsers] = useState([]);
    const fetchedUsersRef = useRef([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        setLoading(true);
        const relayCollection = collection(db, 'users');

        // Listen for real-time updates using onSnapshot
        const unsubscribe = onSnapshot(relayCollection, (snapshot) => {
            const userList = snapshot.docs.map(doc => ({
                id: doc.id, // Get document ID
                ...doc.data() // Spread other fields (like relay_name)
            }));
            fetchedUsersRef.current = [...userList];
            setUsers(userList);
            // let relay =relayList.find
            console.log(`list of user ${userList[0].username}`)
            setLoading(false);

            // Update the state with the new relay data
        }, (error) => {
            setLoading(false);
            console.error("Error fetching relays:", error);
        });

        // Cleanup function to unsubscribe from Firestore listener when the component unmounts
       
        return () => unsubscribe();
        
    }, [relay]);

    useEffect(() => {
        if (relay.allowed_users) {
            setUsers(prevUsers =>
                prevUsers.map(user => ({
                    ...user,
                    hasAccess: relay.allowed_users.includes(user.id.trim())
                }))
            );
        }
    }, [relay]);

    const searchUser = (text) => {
        if (text.trim() != '') {
            console.log("----------Searching users------------->")
            const lowercasedSearchText = text.toLowerCase();
            const filtered = users.filter(user =>
                user.username.toLowerCase().includes(lowercasedSearchText)
            );
            setUsers(filtered);
        } else {
            console.log("----------Setting default users------------->" + fetchedUsersRef.current.length)
            setUsers(fetchedUsersRef.current);
        }
        // setSelectedRelay(relay);  // Update the state with the selected relay
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleAllowAccess = async (userId) => {
        try {
            const relayRef = doc(db, "relays", relay.id); // Reference to the specific relay document
            await updateDoc(relayRef, {
                allowed_users: arrayUnion(userId) // Add user ID to allowed_users array
            });

            console.log(`User ${userId} allowed access to ${relay.relay_name}`);
        } catch (error) {
            console.error("Error allowing access:", error);
        }
    };

    const handleRemoveAccess = async (userId) => {
        try {
            const relayRef = doc(db, "relays", relay.id); // Reference to the specific relay document
            await updateDoc(relayRef, {
                allowed_users: arrayRemove(userId) // Remove user ID from allowed_users array
            });

            console.log(`User ${userId} removed access from ${relay.relay_name}`);
        } catch (error) {
            console.error("Error removing access:", error);
        }
    };

    return (
        <div key="userTab" className="container-fluid tab-container">

            <div className='search-and-add-button'>
                <div className='col'>
                    <TextField id="filled-basic" label="Search User" variant="filled" onChange={(event) => {
                        searchUser(event.target.value);
                    }} sx={{
                        width: '300px',

                        '& .MuiFilledInput-root': {
                            backgroundColor: 'rgba(58, 109, 140, 0.3)', // Optional: Change background color
                            border: '1px solid white', // Change border color
                            borderRadius: '10px',
                            color: 'white',
                            textDecoration: 'none', // Remove underline
                            '&:before': { // Remove underline before focus
                                borderBottom: 'none',
                            },
                            '&:after': { // Remove underline after focus
                                borderBottom: 'none',
                            },
                            // Optional: Adjust border radius
                        },
                        '& .MuiFilledInput-root:hover': {
                            backgroundColor: 'rgba(58, 109, 140, 0.3)', // Optional: Change background color
                            border: '1px solid white', // Change border color
                            borderRadius: '10px',
                            color: 'white',
                            textDecoration: 'none', // Remove underline
                            '&:before': { // Remove underline before focus
                                borderBottom: 'none',
                            },
                            '&:after': { // Remove underline after focus
                                borderBottom: 'none',
                            },// Optional: Adjust border radius
                        },
                        '& .MuiFilledInput-root:focus': {
                            backgroundColor: 'rgba(58, 109, 140, 0.3)', // Optional: Change background color
                            border: '1px solid white', // Change border color
                            borderRadius: '10px',
                            color: 'white'// Optional: Adjust border radius
                        },
                        '& .MuiInputLabel-root': {

                            color: 'white', // Change label color
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: 'grey', // Change label color when focused
                        },
                    }} />
                </div>

                <div className='col d-flex justify-content-end padding'>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" color="secondary" startIcon={<AddIcon />} onClick={handleClickOpen} sx={{ backgroundColor: '#3A6D8C', color: 'white', fontWeight: 'bold' }}>
                            Add New User
                        </Button>

                    </Stack>
                </div>
            </div>
            {
                loading ? <div className='loader-container' ><SyncLoader  loading={true} color='white'/></div> : <div className='scroll-container my-4 py-0'>
                    {
                        users.map((user) => (
                            <div className={(relay.allowed_users??[]).includes(user.id.trim()) ? 'row all-users-container allowed-border' : 'row all-users-container not-allowed-border'}>
                                <div className='col all-user-title' key={user.username}> {user.username}</div>
                                <div className='col d-flex justify-content-end'>
                                    {
                                        relay.allowed_users.includes(user.id.trim()) ?
                                            <Stack className='px-3' direction="row" spacing={2}>
                                                <Button className='small-font' variant="contained" sx={{ backgroundColor: '#FF4500', color: 'white' ,fontSize: { xs: '12px', md: '14px' },}} startIcon={<BlockIcon />} onClick={() => handleRemoveAccess(user.id.trim())}>
                                                    Remove Acces For {relay.relay_name}
                                                </Button>

                                            </Stack> : <Stack className='px-3' direction="row" spacing={2}>
                                                <Button variant="contained" sx={{ backgroundColor: 'green', color: 'white' }} startIcon={<VerifiedUserIcon />} onClick={() => handleAllowAccess(user.id.trim())}>
                                                    Allow access for {relay.relay_name}
                                                </Button>

                                            </Stack>
                                    }

                                    <div ></div>

                                    <Stack direction="row" spacing={2}>
                                        <Button variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Delete
                                        </Button>

                                    </Stack>
                                </div>
                            </div>

                        ))
                    }
                </div>
            }
            <AddUserForm open={open} setOpen={setOpen} setLoading={setLoading} />
            <ToastContainer />
        </div>
    );
}

export default AllUsersTab;